import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "Educativo",
  icon: "🧠",
  templates: [
    {
      title: "Spiega in Modo Semplice",
      content: `Spiega l'argomento [come i vaccini allenano il sistema immunitario] in modo chiaro e coinvolgente per gli ascoltatori.
- Immagina di spiegarlo a [un adolescente curioso senza conoscenze scientifiche].
- Usa un'analogia familiare: [paragonalo a un'esercitazione antincendio — ti eserciti per qualcosa così sei pronto quando succede davvero].
- Evita il gergo; quando un termine tecnico è necessario, definiscilo subito in linguaggio semplice.
- Scrivi con un tono caldo e incoraggiante che faccia sentire l'ascoltatore intelligente, senza essere condiscendente.`
    },
    {
      title: "Voiceover Documentaristico",
      content: `Scrivi una narrazione voiceover in stile documentario.
- Soggetto: [la vita quotidiana dei venditori di cibo di strada a Bangkok].
- Angolazione: [l'artigianato, l'orgoglio e la conoscenza generazionale dietro piatti che sembrano semplici ma richiedono anni per essere padroneggiati].
- Tono: [rispettoso, vivido e senza fretta — lascia che le scene respirino].
- Includi dettagli sensoriali che aiutino l'ascoltatore a immaginare e sentire l'ambiente: [lo sfrigolío di un wok, l'umidità del mercato mattutino, i movimenti precisi delle mani di un venditore che ha fatto questo diecimila volte].
- Scrivi al presente per l'immediatezza.`
    },
    {
      title: "Meditazione Guidata",
      content: `Scrivi uno script di meditazione guidata progettato per essere ascoltato.
- Obiettivo: [rilasciare la tensione dopo una lunga giornata lavorativa e scivolare dolcemente nella serata].
- Guida l'ascoltatore a visualizzare [un tranquillo lungolago al tramonto — luce calda sull'acqua, una brezza leggera, il suono di uccelli lontani che si sistemano per la notte].
- Tono: [calmo, senza fretta e radicante].
- Durata parlata approssimativa: [8 minuti].
- Usa abbondanti pause naturali (indicate con "...") tra le istruzioni. Mantieni le frasi brevi e delicate. Evita cambiamenti improvvisi di energia.`
    }
  ]
};
